module.exports = __webpack_public_path__ + "static/media/sensorsDark.15a23dc2.svg";